import { render, staticRenderFns } from "./mdTalkBox.vue?vue&type=template&id=68898caf&scoped=true&"
import script from "./mdTalkBox.vue?vue&type=script&lang=js&"
export * from "./mdTalkBox.vue?vue&type=script&lang=js&"
import style0 from "./mdTalkBox.vue?vue&type=style&index=0&id=68898caf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68898caf",
  null
  
)

export default component.exports